// extracted by mini-css-extract-plugin
export default {"pleaseChoose":"crowd-management-page_pleaseChoose__+X3pz"};